import React from "react";

import {
  CardBody,
  Row, 

} from "shards-react";
import SocialNetworkAll from './SocialNetworkAll'

export default class HiddenBoxNetwork extends React.Component {
  constructor(props) {
    super(props);
    console.log(props.topicId);
    
}
  render() {
    return (
      // <div> I was hidden </div>
      <CardBody className="px-0 py-0">  
        <h6 class='text-white pt-2 pb-1 my-1'>Orange for top influencers, cyan for non-top influencers, and white for regular users.</h6>
        <div className="py-0"><SocialNetworkAll topicId={this.props.topicId} /></div>
        

      </CardBody>
     
      );
  }
}
